import { Component, EventEmitter, inject, Input, input, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ButtonComponent } from '@shared/components/button/button.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { BudgetActivityAttributes, listBudgetActivitiesQuery } from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { InvoiceModel } from '@shared/store/invoice/invoice.model';
import { MainQuery } from '@shared/store/main/main.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

import { MapActivitiesModalComponent } from '../map-activities-modal/map-activities-modal.component';
import {
  MapActivitiesModalParams,
  MapActivitiesModalReturnData,
} from '../map-activities-modal/map-activities-modal.model';

@Component({
  imports: [ButtonComponent, TooltipDirective],
  selector: 'aux-map-activities-no-rows',
  templateUrl: 'map-activities-no-rows.component.html',
})
export class MapActivitiesNoRowsComponent {
  authService = inject(AuthService);
  mainQuery = inject(MainQuery);
  workflowQuery = inject(WorkflowQuery);

  private overlayService = inject(OverlayService);

  attributes = input.required<BudgetActivityAttributes[]>();
  btnTooltip = input.required<string>();
  budgetActivityOptions = input.required<listBudgetActivitiesQuery[]>();
  invoice = input.required<InvoiceModel>();

  @Input() lastUpdated = '';
  @Input() noteId = '';
  @Input() noteMessage = '';
  @Output() saveActivities = new EventEmitter<MapActivitiesModalReturnData>();

  async openMapActivitiesModal(): Promise<void> {
    const ref = this.overlayService.openPopup<
      MapActivitiesModalParams,
      MapActivitiesModalReturnData,
      MapActivitiesModalComponent
    >({
      content: MapActivitiesModalComponent,
      data: {
        attributes: this.attributes(),
        budgetActivityOptions: this.budgetActivityOptions(),
        invoice: this.invoice(),
        items: [],
        lastUpdated: this.lastUpdated,
        noteId: this.noteId,
        noteMessage: this.noteMessage,
      },
      settings: {
        header: 'Map Activities',
        primaryButton: {
          action: (instance) => instance?.save(),
          disabled: (instance) => !!instance?.isSaveButtonDisabled(),
          pendoTag: 'map-activities-save-button',
          tooltip: (instance) => instance?.saveButtonTooltip() || '',
        },
      },
    });

    const { data } = await firstValueFrom(ref.afterClosed$);

    if (data) {
      this.saveActivities.emit(data);
    }
  }
}
